import { createContext, ReactNode } from 'react'

import { CurrentFilterTemplate } from '@/store/beneficiary-list-filters/types'

export type BeneficiaryListAsSheetOptions = {
  filterTemplate?: CurrentFilterTemplate
  children?: ReactNode
}

export type BeneficiaryListAsSheetContextType = {
  open: boolean
  setOpen: {
    (open: true, options?: BeneficiaryListAsSheetOptions): void
    (open: false): void
  }
}

export const BeneficiaryListAsSheetContext =
  createContext<BeneficiaryListAsSheetContextType | null>(null)
